import type { ComponentProps } from 'react';

import { cn } from './cn';

/** Classes de campo de texto do Lume, reusadas por máscara, dinheiro, data e gatilho de select. */
export const fieldControlClass = cn(
  'flex h-control w-full min-w-0 items-center rounded-control border border-input bg-card px-3 text-field text-foreground',
  'transition-[border-color,box-shadow] duration-(--lume-dur-instant) ease-out',
  'placeholder:text-faint',
  'focus-visible:border-ring focus-visible:shadow-focus focus-visible:outline-none',
  'aria-invalid:border-error aria-invalid:shadow-[0_0_0_3px_var(--lume-err-wash)] aria-invalid:focus-visible:shadow-invalid',
  'disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground',
  // Botão também casa :read-only; só campo editável ganha o fundo de somente leitura.
  '[&:is(input,textarea):read-only]:bg-muted',
);

export type InputProps = ComponentProps<'input'>;

/** Campo de texto. Tamanho e fonte seguem a plataforma (16px no celular, sem zoom no iOS). */
export function Input({ className, type = 'text', ...props }: InputProps) {
  return <input type={type} data-slot="input" className={cn(fieldControlClass, className)} {...props} />;
}
